// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--jLicQ";
export var figure = "styles-module--figure--o9Dnn";
export var image = "styles-module--image--jBgSs";
export var caption = "styles-module--caption--oxtj5";